var map = {
	"./goldcoin/level/Bronze.png": 85690,
	"./goldcoin/level/Diamond.png": 48333,
	"./goldcoin/level/Emerald.png": 14430,
	"./goldcoin/level/Gold.png": 6879,
	"./goldcoin/level/Platinum.png": 30650,
	"./goldcoin/level/Ruby.png": 9061,
	"./goldcoin/level/Silver.png": 68801,
	"./goldcoin/level/Wish.png": 78736,
	"./memetown/level/Bronze.png": 76969,
	"./memetown/level/Diamond.png": 14457,
	"./memetown/level/Emerald.png": 54280,
	"./memetown/level/Gold.png": 43859,
	"./memetown/level/Platinum.png": 98246,
	"./memetown/level/Ruby.png": 82347,
	"./memetown/level/Silver.png": 12829,
	"./memetown/level/Wish.png": 18963,
	"./reflection/level/Bronze.png": 9040,
	"./reflection/level/Diamond.png": 97456,
	"./reflection/level/Emerald.png": 58531,
	"./reflection/level/Gold.png": 48993,
	"./reflection/level/Platinum.png": 82867,
	"./reflection/level/Ruby.png": 77339,
	"./reflection/level/Silver.png": 91250,
	"./reflection/level/Wish.png": 63044,
	"./tapcoin/level/Bronze.png": 81649,
	"./tapcoin/level/Diamond.png": 17308,
	"./tapcoin/level/Emerald.png": 39975,
	"./tapcoin/level/Gold.png": 88027,
	"./tapcoin/level/Platinum.png": 96604,
	"./tapcoin/level/Ruby.png": 29676,
	"./tapcoin/level/Silver.png": 97004,
	"./tapcoin/level/Wish.png": 85792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25847;